export default "__VITE_ASSET__CuSzhD5w__"